export function getVisibleViewportMetrics(visualViewport, layoutHeight) {
  const fallbackHeight = Math.max(1, Math.round(Number(layoutHeight) || 1));
  const height = Math.max(1, Math.round(Number(visualViewport?.height) || fallbackHeight));
  const offsetTop = Math.max(0, Math.round(Number(visualViewport?.offsetTop) || 0));
  const obscuredHeight = Math.max(0, fallbackHeight - (height + offsetTop));

  return {
    height,
    offsetTop,
    keyboardOpen: obscuredHeight > 100,
  };
}
